export default {
  name: 'KBreadcrumb',
  provide() {
    return {
      breadcrumb: this,
    }
  },
  props: {
    separator: {
      type: String,
      default: '/',
    },
    separatorIcon: { // 使用 sati 库图标作为分隔符
      type: String,
      default: null,
    },
    largeTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {
  },
  methods: {},
  render() {
    const style = {}

    const css = {
      'km-breadcrumb': true,
      'km-breadcrumb--large-title': this.largeTitle,
    }

    const attrs = {}

    const props = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <ul
        {...data}>
        {this.$slots.default}
      </ul>
    )
  },
}
